export default "__VITE_ASSET__907b579f__"